import { render, staticRenderFns } from "./moreCommunity.vue?vue&type=template&id=f0021f2e&scoped=true"
import script from "./moreCommunity.vue?vue&type=script&lang=js"
export * from "./moreCommunity.vue?vue&type=script&lang=js"
import style0 from "./moreCommunity.vue?vue&type=style&index=0&id=f0021f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0021f2e",
  null
  
)

export default component.exports